import { FiShoppingCart } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';
import { useProductContext } from '../../product/context/ProductContext.tsx';
import { ROUTE_NAME_OPTIONS } from '../../utils/constants.ts';
import { formatPriceWithDots } from '../../utils/utils.ts';

const FloatingCartBar = () => {
  const { shoppingCart } = useProductContext();
  const navigate = useNavigate();

  if (shoppingCart.totalItems === 0) return null;

  return (
    <div
      className="floating-cart-bar"
      onClick={() => navigate(`/${ROUTE_NAME_OPTIONS.SHOPPING_CART}`)}
    >
      <FiShoppingCart size={20} />
      <span>{shoppingCart.totalItems} productos</span>
      <span className="floating-cart-bar__price">
        ${formatPriceWithDots(shoppingCart.totalPrice)}
      </span>
    </div>
  );
};

export default FloatingCartBar;
